import { render } from "./RegisteredUsers.vue?vue&type=template&id=efae2e30&scoped=true"
import script from "./RegisteredUsers.vue?vue&type=script&lang=js"
export * from "./RegisteredUsers.vue?vue&type=script&lang=js"

import "./RegisteredUsers.vue?vue&type=style&index=0&id=efae2e30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efae2e30"]])

export default __exports__